<template>
      <el-button class="user-guide" @click="goUserGuideSite"><img src="@/assets/icon_user_guide.svg"/><span class="guide-text"> User Guide</span></el-button>
</template>

<script>
import { findDicValue } from '@/services/dictionary.service';
import Constant from '@/common/Constant';
export default {
  name: 'UserGuide',
  data () {
    return {
      guideUrl: ''
    }
  },
  methods: {
    async getUserGuide () {
      let data = await findDicValue(Constant.CONFIG_BUSINESS, Constant.USER_GUIDE_URL);
      this.guideUrl = data.data[0].dictValue;
    },
    goUserGuideSite () {
      window.open(this.guideUrl)
    }
  },
  mounted () {
    this.getUserGuide();
  }
}
</script>

<style lang="scss" scoped>
  img{
    width: 12px;
    height: 15px;
    line-height: inherit;
    vertical-align: middle;
  }
  .user-guide{
    z-index: 10;
    text-align: center;
    position: absolute;
    margin-top: 80px;
    margin-left: 90%;
    height: 32px;
    padding-top: 6px;
  }
  .guide-text{
    vertical-align: middle;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserGuide.vue